<div class="create-schedule-page">
  <p *ngIf="isLoadingSchedule" class="schedule-load-banner" role="status">Loading schedule details…</p>
  <p *ngIf="scheduleLoadError" class="schedule-load-banner schedule-load-banner--error" role="alert">
    {{ scheduleLoadError }}
  </p>

  <nav
    class="wizard-stepper"
    [attr.aria-label]="'Create schedule, step ' + (currentStepIndex + 1) + ' of ' + steps.length"
  >
    <ol class="wizard-stepper__list">
      <li *ngFor="let step of steps; let i = index" class="wizard-stepper__item">
        <button
          type="button"
          class="wizard-stepper__node"
          [class.wizard-stepper__node--active]="i === currentStepIndex"
          [class.wizard-stepper__node--done]="i < currentStepIndex"
          (click)="goToStep(i)"
          [attr.aria-current]="i === currentStepIndex ? 'step' : null"
          [attr.aria-label]="'Step ' + (i + 1) + ': ' + step.title"
        >
          <span class="wizard-stepper__check material-symbols-outlined" *ngIf="i < currentStepIndex" aria-hidden="true">check</span>
          <span class="wizard-stepper__index" *ngIf="i >= currentStepIndex">{{ i + 1 }}</span>
        </button>
        <div class="wizard-stepper__meta">
          <span class="wizard-stepper__title">{{ step.title }}</span>
          <span class="wizard-stepper__subtitle">{{ step.subtitle }}</span>
        </div>
      </li>
    </ol>
  </nav>

  <!-- Step panels -->
  <div class="schedule-card">
    <ng-container [ngSwitch]="currentStepIndex">
      <!-- Step 1: Suites -->
      <ng-container *ngSwitchCase="0">
        <header class="card-header">
          <div>
            <h2>Select Suite & Name your Schedule</h2>
            <p>Select one or more test suites to schedule and give this schedule a recognisable name.</p>
          </div>
        </header>
        <div class="suite-header-row">
          <div class="suite-header-left">
            <span class="material-symbols-outlined summary-row__icon" aria-hidden="true">layers</span>
            <span><strong>{{ selectedSuiteCount }}</strong> suite{{ selectedSuiteCount === 1 ? '' : 's' }} selected</span>
          </div>
          <div class="suite-header-right">
            <div class="suite-search-group">
              <span class="material-symbols-outlined search-icon" aria-hidden="true">search</span>
              <input type="search" name="suiteFilter" [(ngModel)]="suiteFilterText" placeholder="Search suite name" autocomplete="off" />
            </div>
            <div class="suite-filter-menu" [class.suite-filter-menu--open]="sortMenuOpen">
              <button
                type="button"
                class="filter-icon-btn"
                (click)="sortMenuOpen = !sortMenuOpen"
                title="Sort options"
                aria-label="Sort options"
              >
                <span class="material-symbols-outlined" aria-hidden="true">tune</span>
              </button>
              <div class="filter-dropdown" *ngIf="sortMenuOpen">
                <button
                  type="button"
                  class="filter-option"
                  [class.filter-option--active]="sortOption === 'CUSTOM'"
                  (click)="onSortOptionChange('CUSTOM'); sortMenuOpen = false"
                >
                  <span class="material-symbols-outlined" aria-hidden="true">unfold_more</span>
                  <span>Custom order</span>
                </button>
                <button
                  type="button"
                  class="filter-option"
                  [class.filter-option--active]="sortOption === 'NAME_ASC'"
                  (click)="onSortOptionChange('NAME_ASC'); sortMenuOpen = false"
                >
                  <span class="material-symbols-outlined" aria-hidden="true">sort_by_alpha</span>
                  <span>Name (A → Z)</span>
                </button>
                <button
                  type="button"
                  class="filter-option"
                  [class.filter-option--active]="sortOption === 'NAME_DESC'"
                  (click)="onSortOptionChange('NAME_DESC'); sortMenuOpen = false"
                >
                  <span class="material-symbols-outlined" aria-hidden="true">sort_by_alpha</span>
                  <span>Name (Z → A)</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="suite-grid" cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="dropSuiteOrder($event)">
          <div
            *ngFor="let suite of filteredSuites; trackBy: trackBySuiteId"
            class="suite-card"
            [class.suite-card--selected]="suite.selected"
            cdkDrag
          >
            <label class="suite-card__label">
              <span class="suite-card__check-wrap">
                <input type="checkbox" class="suite-card__checkbox" [(ngModel)]="suite.selected" [name]="'suite-' + suite.id" (change)="onSuiteSelectionChange(suite)" />
                <span class="suite-card__check" aria-hidden="true"></span>
              </span>
              <strong class="suite-card__name" [title]="suite.name">{{ suite.name }}</strong>
              <span class="suite-card__drag-handle" cdkDragHandle aria-label="Drag to reorder" title="Drag to reorder">⋮⋮</span>
            </label>
          </div>
        </div>

        <p *ngIf="filteredSuites.length === 0" class="field-hint field-hint--warn">No suites match your filter.</p>

        <div class="identity-fields">
          <div class="form-row form-row--2">
            <div class="form-field">
              <label for="schedule-name">Schedule name <span class="req">*</span></label>
              <input id="schedule-name" type="text" name="scheduleName" [(ngModel)]="scheduleName" placeholder="Schedule name" autocomplete="off" />
              <p *ngIf="scheduleName && !isScheduleNameValid()" class="field-hint field-hint--warn">
                Schedule name can only contain letters, numbers, and underscores (_).
              </p>
            </div>
            <div class="form-field">
              <label for="schedule-desc" id="schedule-desc-label" style="display:flex;justify-content:space-between;align-items:center;">
                <span>Description</span>
                <span id="schedule-desc-content">{{ (description || '').length }} / 200</span>
              </label>
              <textarea id="schedule-desc" name="description" [(ngModel)]="description" (ngModelChange)="onDescriptionChange($event)" rows="2" maxlength="200" placeholder="Short description of this schedule's purpose"></textarea>
            </div>
          </div>
        </div>

        <p *ngIf="selectedSuiteCount === 0" class="field-hint field-hint--warn">Select at least one suite to continue.</p>
        <p *ngIf="selectedSuiteCount > 0 && !(scheduleName || '').trim()" class="field-hint field-hint--warn">A schedule name is required.</p>
      </ng-container>

      <!-- Step 4: Configure schedule -->
      <ng-container *ngSwitchCase="3">
        <header class="card-header">
          <div>
            <h2>Configure Schedule</h2>
            <p>Set the start date, time window, timezone, and recurrence pattern.</p>
          </div>
        </header>

        <div class="configure-form">
          <div class="form-row form-row--4">
            <div class="form-field" [class.field--frozen]="isEditMode">
              <label for="cfg-start-date">Start date <span class="req">*</span></label>
              <input id="cfg-start-date" type="date" name="startDate" [(ngModel)]="startDate" (ngModelChange)="onStartDateChange($event)" [attr.min]="startDateMin" [attr.max]="startDateMax" [disabled]="isEditMode" />
              <p *ngIf="startDate && !isDateWithinAllowedRange(startDate)" class="field-hint field-hint--warn">Start date must be year 2099 or earlier.</p>
              <p *ngIf="!isEditMode && startDate && isDateWithinAllowedRange(startDate) && !isStartDateValid()" class="field-hint field-hint--warn">Start date cannot be in the past.</p>
            </div>

            <div class="form-field time-field">
              <label>Start time <span class="req">*</span></label>
              <div class="time-picker-container" #startTimeContainer>
                <div class="time-picker-group">
                  <!-- Hours Dropdown + Input -->
                  <div class="time-picker-control" #hourControl>
                    <div class="time-picker-input-group">
                      <input
                        #hourInput
                        type="text"
                        [(ngModel)]="startTimeHour"
                        (input)="onTimeInputChange('hour', $event)"
                        (keydown)="onTimeInputKeyDown('hour', $event)"
                        (blur)="validateTimeInput('hour')"
                        (focus)="openDropdown('hour')"
                        placeholder="HH"
                        class="time-picker-input"
                        maxlength="2"
                        autocomplete="off"
                      />
                      <button
                        type="button"
                        class="time-picker-toggle"
                        (click)="toggleDropdown('hour')"
                        aria-label="Toggle hours"
                      >
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0 3l6 6 6-6z" fill="currentColor"/>
                        </svg>
                      </button>
                    </div>
                    <div class="time-picker-dropdown" *ngIf="openDropdowns.hour">
                      <div class="time-picker-options">
                        <button
                          *ngFor="let hour of filteredHours"
                          type="button"
                          class="time-picker-option"
                          [class.tz-highlighted]="hour === highlightedHour"
                          (click)="selectTime('hour', hour)"
                        >
                          {{ hour }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <span class="time-picker-separator">:</span>

                  <!-- Minutes Dropdown + Input -->
                  <div class="time-picker-control" #minuteControl>
                    <div class="time-picker-input-group">
                      <input
                        #minuteInput
                        type="text"
                        [(ngModel)]="startTimeMinute"
                        (input)="onTimeInputChange('minute', $event)"
                        (keydown)="onTimeInputKeyDown('minute', $event)"
                        (blur)="validateTimeInput('minute')"
                        (focus)="openDropdown('minute')"
                        placeholder="MM"
                        class="time-picker-input"
                        maxlength="2"
                        autocomplete="off"
                      />
                      <button
                        type="button"
                        class="time-picker-toggle"
                        (click)="toggleDropdown('minute')"
                        aria-label="Toggle minutes"
                      >
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0 3l6 6 6-6z" fill="currentColor"/>
                        </svg>
                      </button>
                    </div>
                    <div class="time-picker-dropdown" *ngIf="openDropdowns.minute">
                      <div class="time-picker-options">
                        <button
                          *ngFor="let minute of filteredMinutes"
                          type="button"
                          class="time-picker-option"
                          [class.tz-highlighted]="minute === highlightedMinute"
                          (click)="selectTime('minute', minute)"
                        >
                          {{ minute }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- AM/PM Dropdown  -->
                  <div class="time-picker-control" #ampmControl>
                    <div class="time-picker-input-group">
                      <button
                        type="button"
                        class="time-picker-input ampm-display"
                        (click)="toggleDropdown('ampm')"
                        (keydown)="onAmPmKeyDown($event)"
                      >{{ startTimeAmPm }}</button>
                      <button
                        type="button"
                        class="time-picker-toggle"
                        (click)="toggleDropdown('ampm')"
                        aria-label="Toggle AM/PM"
                      >
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0 3l6 6 6-6z" fill="currentColor"/>
                        </svg>
                      </button>
                    </div>
                    <div class="time-picker-dropdown" *ngIf="openDropdowns.ampm">
                      <div class="time-picker-options ampm-options">
                        <button
                          *ngFor="let ap of ['AM','PM']"
                          type="button"
                          class="time-picker-option"
                          [class.selected]="ap === startTimeAmPm"
                          (click)="selectAmPm(ap)"
                        >{{ ap }}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p *ngIf="(!startTime || !isStartTimeValid())" class="field-hint field-hint--warn">Enter a valid start time in 12-hour format and future time.</p>
            </div>

            <div class="form-field time-field">
              <label for="cfg-timezone">Timezone <span class="req">*</span></label>
              <div class="time-picker-control timezone-dropdown" #timezoneControl>
                <div class="time-picker-input-group">
                  <input
                    type="text"
                    id="cfg-timezone"
                    name="timezone"
                    class="time-picker-input"
                    placeholder="Search or choose timezone"
                    #timezoneInput
                    [(ngModel)]="timezoneInputValue"
                    [readonly]="!timezoneDropdownOpen"
                    (focus)="openTimezoneDropdown()"
                    (input)="onTimezoneSearch($any($event).target.value)"
                    (keydown)="onTimezoneKeyDown($event)"
                    (blur)="onTimezoneBlur()"
                    autocomplete="off"
                  />
                  <button
                    type="button"
                    class="time-picker-toggle"
                    (click)="toggleTimezoneDropdown()"
                    aria-label="Toggle timezone list"
                  >
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 3l6 6 6-6z" fill="currentColor"/>
                    </svg>
                  </button>
                </div>
                <div class="time-picker-dropdown" *ngIf="timezoneDropdownOpen">
                  <div class="time-picker-options">
                    <button
                      *ngFor="let tz of filteredTimezoneOptions"
                      type="button"
                      class="time-picker-option"
                      [class.tz-highlighted]="tz === highlightedTimezone"
                      (click)="selectTimezone(tz)"
                    >
                      {{ tz }}
                    </button>
                  </div>
                </div>
              </div>
              <p *ngIf="!isTimezoneValid()" class="field-hint field-hint--warn">Timezone is required and must be selected from the list.</p>
            </div>

            <div class="form-field">
              <label for="cfg-repeat">Repeat <span class="req">*</span></label>
              <select id="cfg-repeat" name="repeat" [(ngModel)]="repeat">
                <option *ngFor="let r of repeatOptions" [value]="r">{{ r }}</option>
              </select>
            </div>
          </div>

          <p *ngIf="endCondition === 'TILL DATE' && endDate && !isEndDateValid()" class="field-hint field-hint--warn">End date cannot be before start date.</p>

          <div class="recurrence-panel" *ngIf="repeat !== 'NEVER'">
            <div class="recurrence-panel__row recurrence-panel__row--inline recurrence-panel__row--end">
              <span class="recurrence-panel__label">End</span>
              <select class="recurrence-panel__select" name="endCondition" [(ngModel)]="endCondition" (ngModelChange)="onEndConditionChange($event)">
                <option *ngFor="let e of endConditionOptions" [value]="e.value">{{ e.label }}</option>
              </select>
              <input
                *ngIf="endCondition === 'TILL DATE'"
                id="cfg-end-condition-date"
                type="date"
                class="recurrence-panel__date"
                name="endDate"
                [(ngModel)]="endDate"
                [min]="startDate || startDateMin"
                [attr.max]="startDateMax"
              />
              <p *ngIf="endCondition === 'TILL DATE' && endDate && !isDateWithinAllowedRange(endDate)" class="field-hint field-hint--warn">End date must be year 2099 or earlier.</p>
              <p *ngIf="endCondition === 'TILL DATE' && endDate && isDateWithinAllowedRange(endDate) && !isEndDateValid()" class="field-hint field-hint--warn">End date cannot be before start date.</p>
              <div *ngIf="endCondition === 'AFTER'" class="recurrence-panel__after">
                  <input
                  id="cfg-end-after-count"
                  type="number"
                  class="recurrence-panel__num"
                  name="endAfterCount"
                  [(ngModel)]="endAfterCount"
                  (ngModelChange)="validatePositiveInteger('endAfterCount', $event)"
                  (keypress)="preventInvalidInput($event)"
                  min="1"
                  step="1"
                />
                <span class="recurrence-panel__suffix">trigger(s)</span>
              </div>
            </div>

            <div *ngIf="repeat === 'WORK WEEK'" class="form-field recurrence-panel__weekdays">
              <label>Work days</label>
              <div class="days-button-group">
                <button
                  type="button"
                  class="day-button"
                  [class.day-button--selected]="selectedWorkWeekDays.includes(1)"
                  (click)="toggleWorkWeekDay(1, !selectedWorkWeekDays.includes(1))"
                >
                  M
                </button>
                <button
                  type="button"
                  class="day-button"
                  [class.day-button--selected]="selectedWorkWeekDays.includes(2)"
                  (click)="toggleWorkWeekDay(2, !selectedWorkWeekDays.includes(2))"
                >
                  T
                </button>
                <button
                  type="button"
                  class="day-button"
                  [class.day-button--selected]="selectedWorkWeekDays.includes(3)"
                  (click)="toggleWorkWeekDay(3, !selectedWorkWeekDays.includes(3))"
                >
                  W
                </button>
                <button
                  type="button"
                  class="day-button"
                  [class.day-button--selected]="selectedWorkWeekDays.includes(4)"
                  (click)="toggleWorkWeekDay(4, !selectedWorkWeekDays.includes(4))"
                >
                  T
                </button>
                <button
                  type="button"
                  class="day-button"
                  [class.day-button--selected]="selectedWorkWeekDays.includes(5)"
                  (click)="toggleWorkWeekDay(5, !selectedWorkWeekDays.includes(5))"
                >
                  F
                </button>
              </div>
            </div>

            <div *ngIf="repeat === 'MONTHLY'" class="form-field recurrence-panel__monthly-mode">
              <label>Monthly recurrence mode</label>
              <div class="form-row form-row--2">
                <label class="radio-option">
                  <input type="radio" name="monthlyMode" [(ngModel)]="monthlyMode" value="fixed" />
                  <span>Fixed date (e.g., 15th of each month)</span>
                </label>
                <label class="radio-option">
                  <input type="radio" name="monthlyMode" [(ngModel)]="monthlyMode" value="ordinal" />
                  <span>Ordinal (e.g., 3rd Tuesday)</span>
                </label>
              </div>

              <div *ngIf="monthlyMode === 'fixed'" class="form-row form-row--2">
                <div class="form-field">
                  <label for="monthly-day">Day of month (1-31, 0=last day)</label>
                  <input id="monthly-day" type="number" name="monthlyDay" [(ngModel)]="monthlyDay" min="0" max="31" />
                </div>
              </div>

              <div *ngIf="monthlyMode === 'ordinal'" class="form-row form-row--2">
                <div class="form-field">
                  <label for="ordinal-week">Week of month</label>
                  <select id="ordinal-week" name="monthlyOrdinalWeek" [(ngModel)]="monthlyOrdinalWeek">
                    <option *ngFor="let w of ordinalWeeks" [value]="w.value">{{ w.label }}</option>
                  </select>
                </div>
                <div class="form-field">
                  <label for="ordinal-day">Day of week</label>
                  <select id="ordinal-day" name="monthlyOrdinalDayOfWeek" [(ngModel)]="monthlyOrdinalDayOfWeek">
                    <option *ngFor="let d of daysOfWeek" [value]="d.value">{{ d.label }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div *ngIf="repeat === 'WEEKLY'" class="form-field recurrence-panel__weekdays">
              <label>Days of week</label>
              <div class="days-button-group">
                <button
                  *ngFor="let day of daysOfWeek"
                  type="button"
                  class="day-button"
                  [class.day-button--selected]="selectedWeeklyDays.includes(day.value)"
                  (click)="toggleWeeklyDay(day.value, !selectedWeeklyDays.includes(day.value))"
                >
                  {{ day.label.charAt(0) }}
                </button>
              </div>
            </div>

            <div *ngIf="repeat === 'YEARLY'" class="recurrence-panel__yearly recurrence-panel__row recurrence-panel__row--inline">
              <label class="recurrence-panel__label recurrence-panel__label--compact" for="yearly-date">Pick a month and day</label>
              <input
                id="yearly-date"
                type="date"
                name="yearlyDate"
                class="recurrence-panel__date"
                [(ngModel)]="yearlyDate"
                (change)="syncYearlyDateToMonthDay()"
                [min]="startDate || startDateMin"
                [attr.max]="startDateMax"
              />
              <p *ngIf="yearlyDate && !isDateWithinAllowedRange(yearlyDate)" class="field-hint field-hint--warn">Yearly date must be year 2099 or earlier.</p>
              <p *ngIf="yearlyDate && isDateWithinAllowedRange(yearlyDate) && !isYearlyDateValid()" class="field-hint field-hint--warn">Yearly date cannot be before the start date.</p>
            </div>

            <div class="recurrence-panel__row recurrence-panel__row--inline">
              <span class="recurrence-panel__label">Every</span>
              <input
                type="number"
                class="recurrence-panel__num"
                name="frequencyEvery"
                [(ngModel)]="frequencyEvery"
                (ngModelChange)="validatePositiveInteger('frequencyEvery', $event)"
                (keypress)="preventInvalidInput($event)"
                min="1"
                step="1"
              />
              <span class="recurrence-panel__suffix">{{ repeatUnitLabel }}</span>
            </div>
            <p *ngIf="endCondition === 'TILL DATE' && endDate && isEndDateValid() && everyXDaysMax > 0"
               [class]="'field-hint ' + (isEveryXDaysValid() ? 'field-hint--info' : 'field-hint--warn')">
              <ng-container *ngIf="everyXDaysMax === 1; else rangeMsg">The recurrence interval must be 1 day.</ng-container>
              <ng-template #rangeMsg>Allowed recurrence interval: 1–{{ everyXDaysMax }} {{ everyXDaysMax === 1 ? 'day' : 'days' }}.</ng-template>
            </p>
            <p class="recurrence-summary">
              <strong class="recurrence-summary__lead">Your</strong> {{ recurrenceSummaryRest }}
            </p>
          </div>

          <p *ngIf="repeat === 'NEVER'" class="recurrence-summary">
            <strong class="recurrence-summary__lead">Your</strong> schedule will run only one time at {{ getStartTimeDisplay() }}.
          </p>

          <div class="recurrence-panel__row recurrence-panel__row--backfill">
            <label class="backfill-checkbox-label">
              <span class="backfill-checkbox-wrap">
                <input type="checkbox" class="backfill-checkbox-input" name="backfillAllowed" [(ngModel)]="backfillAllowed" />
                <span class="backfill-checkbox-check" aria-hidden="true"></span>
              </span>
              <span class="backfill-checkbox-text">Backfill</span>
            </label>
            <div *ngIf="backfillAllowed" class="backfill-warning">
              <span class="material-symbols-outlined backfill-warning__icon" aria-hidden="true">info</span>
              <span class="backfill-warning__text">If the scheduled start time is in the past, a backfill execution will be
                triggered immediately as a single execution.</span>
            </div>
          </div>
          
        </div>
      </ng-container>

      <!-- Step 2: Execution occurrences -->
      <ng-container *ngSwitchCase="1">
        <header class="card-header">
          <div>
            <h2>Number of Runs</h2>
            <p>
              On each scheduled trigger, how many times should the suite execute? Use this to run the same suite multiple times per trigger for stress/load testing.
            </p>
          </div>
        </header>

        <div class="occurrences-form">
          <div class="occurrences-card occurrences-card--stepper" *ngIf="!isSequentialMode">
            <div class="occurrences-card__text">
              <label id="occ-exec-label" class="occurrences-card__title">Executions per trigger</label>
              <p class="occurrences-card__desc">Number of times the suite runs each time the schedule fires</p>
            </div>
            <div class="number-stepper" role="group" aria-labelledby="occ-exec-label">
              <button
                type="button"
                class="number-stepper__btn"
                (click)="bumpExecutionsPerTrigger(-1)"
                [disabled]="true"
                aria-label="Decrease executions per trigger"
              >
                −
              </button>
              <input
                type="number"
                class="number-stepper__input"
                name="executionsPerTrigger"
                [(ngModel)]="executionsPerTrigger"
                min="1"
                max="99"
                step="1"
                disabled
              />
              <button
                type="button"
                class="number-stepper__btn"
                (click)="bumpExecutionsPerTrigger(1)"
                [disabled]="true"
                aria-label="Increase executions per trigger"
              >
                +
              </button>
            </div>
          </div>

          <div class="occurrences-cols">
            <div class="occurrences-field">
              <label for="occ-delay" class="occurrences-field__label">
                {{ isSequentialMode ? 'Delay between suite executions' : 'Delay between executions (seconds)' }}
              </label>
              <select *ngIf="!isSequentialMode" disabled id="occ-delay" name="delayParallel" [ngModel]="0">
                <option [ngValue]="0">No delay</option>
              </select>
              <select *ngIf="isSequentialMode" id="occ-delay" name="delayPreset" [(ngModel)]="delayPreset" (ngModelChange)="onDelayPresetChange()">
                <option *ngFor="let d of sequentialDelayOptions" [ngValue]="d.value">{{ d.label }}</option>
              </select>
              <input
                *ngIf="isSequentialMode && isCustomDelay"
                type="number"
                id="occ-delay-custom"
                name="delayCustomSeconds"
                [(ngModel)]="delayBetweenExecutions"
                min="0"
                [max]="maxSequentialDelaySec"
                step="1"
                placeholder="Seconds (max {{ maxSequentialDelaySec }})"
                title="Maximum delay is 10 minutes ({{ maxSequentialDelaySec }} seconds)"
                aria-label="Custom delay in seconds"
              />
              <p *ngIf="isSequentialMode && isCustomDelay && !isSequentialDelayValid" class="occurrences-field__hint">
                Enter a whole number of seconds between 0 and {{ maxSequentialDelaySec }} (maximum delay is 10 minutes)
              </p>
              <p class="occurrences-field__hint">
                {{ isSequentialMode ? 'Time to wait after one suite finishes before the next one starts' : 'Time to wait between consecutive executions in the same trigger' }}
              </p>
            </div>

            <div class="occurrences-field">
              <label for="occ-mode" class="occurrences-field__label">Mode</label>
              <select id="occ-mode" name="executionMode" [(ngModel)]="executionMode">
                <option *ngFor="let m of executionModeOptions" [ngValue]="m.value">{{ m.label }}</option>
              </select>
              <p class="occurrences-field__hint">
                {{ isSequentialMode ? 'Run the selected suites one after another, in the order selected' : 'Run executions simultaneously' }}
              </p>
            </div>
          </div>

          <div class="occurrences-card" *ngIf="isSequentialMode">
            <div class="occurrences-card__text">
              <label for="occ-continue" class="occurrences-card__title">Continue if a suite fails or is aborted</label>
              <p class="occurrences-card__desc">
                When unchecked, the remaining suites are aborted as soon as one suite fails or is aborted
              </p>
            </div>
            <input type="checkbox" id="occ-continue" name="continueOnFailure" [(ngModel)]="continueOnFailure" />
          </div>

          <div class="occurrences-card" *ngIf="isSequentialMode">
            <div class="occurrences-card__text">
              <span class="occurrences-card__title">Execution order</span>
              <p class="occurrences-card__desc">Suites run top to bottom. Drag to reorder or use the arrows.</p>
            </div>
            <ol class="sequence-list" cdkDropList (cdkDropListDropped)="dropSequence($event)">
              <li *ngFor="let suite of sequencedSuites; let i = index; trackBy: trackBySuiteId" class="sequence-item" cdkDrag>
                <span class="sequence-item__no">{{ i + 1 }}</span>
                <span class="sequence-item__name" [title]="suite.name">{{ suite.name }}</span>
                <span class="sequence-item__actions">
                  <button type="button" (click)="moveSequence(i, -1)" [disabled]="i === 0" aria-label="Move up">↑</button>
                  <button type="button" (click)="moveSequence(i, 1)" [disabled]="i === sequencedSuites.length - 1" aria-label="Move down">↓</button>
                  <span class="sequence-item__handle" cdkDragHandle title="Drag to reorder" aria-label="Drag to reorder">⋮⋮</span>
                </span>
              </li>
            </ol>
          </div>

      
        </div>
      </ng-container>

      <!-- Step 3: Execution configuration -->
      <ng-container *ngSwitchCase="2">
        <header class="card-header">
          <div>
            <h2>Execution Configuration</h2>
            <p>
              Configure master execution settings. Each attached suite can optionally override these settings individually.
            </p>
          </div>
        </header>

        <!-- Embedded execution container component -->

        <div class="exec-config">
          <div class="exec-master-card">
            <div class="exec-master-card__head">
              <h3 class="exec-master-card__title">Default Execution Settings</h3>
            </div>

            <ze-execution-container
              #masterExecutionContainer
              class="embedded-exec"
              [forceOpen]="true"
              [hideControls]="true"
              [hideCloseIcon]="true"
              [dropped_suite]="selectedSuitesForExecution.length ? selectedSuitesForExecution[0] : null"
              [hideUpload]="true"
              [hideMobileDevice]="true"
              [hideSuiteName]="true"
              [hideLocalExecutionOptions]="true"
              [hideDownloadAndFeedButton]="true"
              (suiteConfigChange)="onMasterExecutionConfigChange()"
              (executionTypesChange)="onMasterExecutionTypesChange($event)">
            </ze-execution-container>
          </div>

          <p class="suite-level">Suite-level overrides</p>
          <p class="form-field__hint exec-overrides-intro">
            Each suite below can override the master configuration and attach suite-specific files.
          </p>

          <div class="note-card note-card--warning" *ngIf="suiteUploadWarning">
            <span class="material-symbols-outlined note-card__icon" aria-hidden="true">warning</span>
            <div>
              <strong>Upload required:</strong> {{ suiteUploadWarning }}
            </div>
          </div>

          <ul class="exec-suite-list">
            <li *ngFor="let suite of selectedSuitesForExecution; trackBy: trackBySuiteId" class="exec-suite-item">
              <div class="exec-suite-row" (click)="expandedSuiteId = expandedSuiteId === suite.id ? null : suite.id">
                <button type="button" class="exec-suite-expand" [attr.aria-expanded]="expandedSuiteId === suite.id">
                  <span class="material-symbols-outlined" aria-hidden="true">{{ expandedSuiteId === suite.id ? 'expand_less' : 'expand_more' }}</span>
                </button>
                <div class="exec-suite-body">
                  <strong class="exec-suite-name">{{ suite.name }}</strong>
                </div>
              </div>

              <div [hidden]="expandedSuiteId !== suite.id" class="exec-suite-expanded">
                <label class="exec-suite-override">
                  <span class="exec-suite-override__check-wrap">
                    <input
                      type="checkbox"
                      class="exec-suite-override__input"
                      [checked]="suiteOverrides.get(suite.id) || isSuiteOverrideRequired(suite.id)"
                      [disabled]="isSuiteOverrideRequired(suite.id)"
                      (change)="onSuiteOverrideChange(suite.id, $event.target.checked)"
                    />
                    <span class="exec-suite-override__check" aria-hidden="true"></span>
                  </span>
                  <span class="exec-suite-override__label">Override master configuration for this suite</span>
                </label>

                <ng-container *ngIf="suiteOverrides.get(suite.id)">
                  <ze-execution-container
                    #suiteExecContainer
                    (csvFileStateChange)="onSuiteCsvStateChange(suite.id)"
                    (csvFileChange)="onSuiteCsvFileChange(suite.id, $event)"
                    (apkFileChange)="onSuiteApkFileChange(suite.id, $event)"
                    (suiteConfigChange)="onSuiteConfigChange(suite.id)"
                    (parametersAvailableChange)="onSuiteParametersAvailableChange(suite.id, $event)"
                    [attr.data-suite-id]="suite.id"
                    class="embedded-exec"
                    [class.param-available]="suite.isParameterized || suiteExecContainer?.isParametersAvailable"
                    [forceOpen]="true"
                    [hideControls]="false"
                    [hideCloseIcon]="true"
                    [dropped_suite]="suite"
                    [masterExecutionConfig]="getSuiteExecutionConfig(suite.id)"
                    [initialExecutionTypes]="getSuiteExecutionTypeOptions(suite.id)"
                    [hideSetCsv]="true"
                    [hideLocalExecutionOptions]="true"
                    [hideDownloadAndFeedButton]="true"
                    [editMode]="!!editScheduleId">
                  </ze-execution-container>
                </ng-container>
              </div>
            </li>
          </ul>
        </div>
      </ng-container>
    </ng-container>

    <div class="note-card" *ngIf="currentStepIndex === 0">
      <span class="material-symbols-outlined note-card__icon" aria-hidden="true">info</span>
      <div>
        <strong>Note:</strong> Multiple suites can be attached to a single schedule.
      </div>
    </div>

    <footer class="card-footer">
      <div class="card-footer__left">
        <button type="button" class="btn btn--ghost" (click)="prev()" [disabled]="isFirstStep">Back</button>
      </div>

      <div class="card-footer__center">
        <span class="step-pill">Step {{ currentStepIndex + 1 }} of {{ steps.length }}</span>
      </div>

      <div class="card-footer__right">
        <button *ngIf="!isLastStep" type="button" class="btn btn--primary" (click)="next()" [disabled]="!canGoNext">
          {{ nextButtonLabel }}
          <span class="material-symbols-outlined btn__icon" aria-hidden="true">arrow_forward</span>
        </button>
        <button *ngIf="isLastStep" type="button" class="btn btn--primary" [class.btn--disabled]="isSaveDisabled" (click)="finish()" [disabled]="isSaveDisabled" [attr.aria-disabled]="isSaveDisabled" [featureActionState]="'SCHEDULER'">
          {{ saveButtonLabel }}
          <span class="material-symbols-outlined btn__icon" aria-hidden="true">check</span>
        </button>
      </div>
    </footer>
  </div>
</div>
